import React, { useRef, useState, useEffect } from 'react';
import Icons from '../Icons';

function ActionDropdown({ offerDetails, offrcnt, index, handleActionCall, warningMsg, warningMsgDefaultText, status }) {
  const [openDropDownID,setOpenDropDownID] = useState(null)
  const actionRef = useRef(null);

  useEffect(() => {
      function handleClickOutside(e) {
        if (openDropDownID && actionRef.current && !actionRef.current.contains(e.target)) {
          setOpenDropDownID(null);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [openDropDownID]);

    const handleDropdownToggle = (offerid, e) => {
        e.stopPropagation(); 
        setOpenDropDownID(openDropDownID === offerid ? null : offerid);
      };

  return (
    <div className='actionButton' ref={actionRef} onClick={(e) => handleDropdownToggle(offerDetails.offerId, e)}>
                    { status==="Rejected" && <span className='status-label'>
                      <Icons name="reason" height="24px" width="24px" ></Icons>
                      {warningMsg !== '' && 
                          <div className = {`notification-reason ${offrcnt > 2 && (offrcnt - index === 1 || index - offrcnt === 0) ? "upp" : "downn"} `}>
                            <div className={`notification-arrow ${offrcnt > 2 && (offrcnt - index === 1 || index - offrcnt === 0)  ? "upp" : "downn"} `}><Icons name="notiarrow" width="12px" height="6px"/></div>
                            <div className='notification-message'>{warningMsgDefaultText}
                              <div style={{color:'#D1D5DB', fontWeight:"400", marginTop:"4px"}}>{warningMsg}</div>
                            </div>
                          </div>
                      }
                    </span>}
                    <span><Icons name="op-dots" height="24px" width="24px" ></Icons></span>
                    
                    {/* {offerDetails.offerId === openDropDownID &&  */}
                      <div 
                        className={`actions-dropdownlist ${offerDetails.offerId === openDropDownID? "open-action":"close-action"} ${offrcnt > 2 && (offrcnt - index === 1 || index - offrcnt === 0) ? "upwards" : "downwards"} `} 
                        
                      >
                        {offerDetails.offerId === openDropDownID && offerDetails?.nextActions.split(',').map((element) => (
                          <button className='action-new' onClick={(e) => {
                            e.stopPropagation();
                            handleActionCall(element, offerDetails.offerId);
                            setOpenDropDownID(null);
                            
                          }}>
                            {element}
                          </button>
                        ))}
                      </div>
                     {/* }  */}
                    </div>
  );
}

export default ActionDropdown;
